/**
 * Dropdown menu

 * Timer for hover exit: better usability
 * Works with keyboard: a11y
 * Desktop menu with touch: doubletap
 * Mobile menu with touch
 * Works at least with 3 levels (probably more)
 */
var component_dropdown_menu = function (args) {
    // setup args
    var menu = args.menu,
        hover_timeout = {}; // Hover timeout needs to be an object, we will store one timeout per menu item

    // validate
    if (!menu) {
        console.log('Invalid drop-down menu');
        return;
    }

    /**
     * Helper: Get all ancestors
     */
    function get_all_ancestors(item, css_class) {
        var result = [];
        var ancestor = item.parentElement;
        while (!ancestor.isEqualNode(menu)) {
            if (ancestor.classList.contains(css_class)) {
                result.push(ancestor);
            }
            ancestor = ancestor.parentElement;
        }
        return result;
    }

    /**
     * Helper: Get closest ancestor
     */
    function get_closest_ancestor(item, css_class) {
        var result = get_all_ancestors(item, css_class);
        if (result.length) {
            return result[0];
        }
        return null;
    }

    function menu_item_has_submenu(li) {
        return li.classList.contains('menu-item-has-children');
    }

    function menu_item_get_caret(li) {
        return li.children[0].children[1].children[0];
    }

    /**
     * Helper: Checks if this instance of component_dropdown_menu is for a desktop menu
     */
    function is_desktop_menu() {
        return (
            menu.classList.contains('primary-navigation') &&
            menu.classList.contains('desktop-menu')
        );
    }

    function menu_item_get_identifier(li) {
        let array = Array.from(li.classList);
        let filtered = [];
        for (let i = 0; i < array.length; i++) {
            if (array[i].includes('menu-item-')) {
                filtered.push(array[i]);
            }
        }
        if (filtered.length === 0) {
            console.error(
                'Could not get an identifier for a dropdown menu item.'
            );
            return '-';
        }
        return filtered[filtered.length - 1];
    }

    /**
     * Helper: Show menu item children <li class="menu-item-has-children">
     */
    function activate_menu_item(li, tap = false) {
        // validate
        if (!li) {
            return;
        }
        if (!menu_item_has_submenu(li)) {
            return;
        }

        // open submenu <ul>
        var ul = li.children[1];
        if (ul) {
            ul.classList.add('-open');

            // check that <ul> fits viewport
            let is_out_of_bounds =
                ul.getBoundingClientRect().right >
                (window.innerWidth || document.documentElement.clientWidth);

            if (is_out_of_bounds) {
                ul.classList.add('-is-out-of-bounds');
            }

            // Reflect the state of the submenu in the menu item
            li.classList.add('-open');
            if (tap) {
                li.classList.add('-is-tapped');
            }

            // Reflect the state of the submenu in the caret
            let caret = menu_item_get_caret(li);
            if (caret) {
                caret.classList.add('-open');
                caret.setAttribute('aria-expanded', 'true');
                if (is_out_of_bounds) {
                    caret.classList.add('-is-out-of-bounds');
                }
            }
        }
    }

    /**
     * Helper: Hide menu item children <li class="menu-item-has-children">
     */
    function deactivate_menu_item(li) {
        // validate
        if (!li) {
            return;
        }
        if (!menu_item_has_submenu(li)) {
            return;
        }

        // close submenu <ul>
        var ul = li.children[1];
        if (ul) {
            ul.classList.remove('-open');
            ul.classList.remove('-is-out-of-bounds');

            // Reflect the state of the submenu in the menu item
            li.classList.remove('-open');
            li.classList.remove('-is-tapped'); // This can come from touchstart event on touch screens

            // Reflect the state of the submenu in the caret
            let caret = menu_item_get_caret(li);
            if (caret) {
                caret.classList.remove('-open');
                caret.classList.remove('-is-out-of-bounds');
                caret.classList.remove('-is-tapped');
                caret.setAttribute('aria-expanded', 'false');
            }
        }
    }

    /**
     * Toggle menu item
     */
    function toggle_menu_item(li, tap = false) {
        if (li.classList.contains('-open')) {
            deactivate_menu_item(li);
        } else {
            activate_menu_item(li, tap);
        }
    }

    /**
     * Helper: Close all submenus. Can also be used to close other submenus, that is; other than the supplied menu item's submenu.
     *
     * @param {*} li                  (Optional) Menu item (<li>) to keep open
     * @param {*} exclude_ancestors   (Optional) If true, supplied menu item's ancestors are kept open also
     * @param {*} exclude_descendants (Optional) If true, supplied menu item's descendants are kept open also
     */
    function close_submenus(
        li = false,
        exclude_ancestors = false,
        exclude_descendants = false
    ) {
        let ancestors = [];
        let descendants = [];

        if (li) {
            // Find ancestors if we want to exclude them
            if (exclude_ancestors) {
                ancestors = get_all_ancestors(li, 'menu-item-has-children');
            }

            // Find descendants if we want to exclude them
            if (exclude_descendants) {
                descendants = Array.from(
                    li.querySelectorAll('.menu-item-has-children')
                );
            }
        }

        // Get all menu items that have submenus
        let all = menu.querySelectorAll('.menu-item-has-children');

        // For each menu item that has a submenu
        for (let i = 0; i < all.length; i++) {
            let close = true;

            if (li) {
                // Check if we should close this menu item's submenu
                // -------------------------------------------------

                close = close && all[i] !== li; // Do not close the supplied menu item's submenu
                close = close && ancestors.indexOf(all[i]) === -1; // Do not close ancestors' submenus
                close = close && descendants.indexOf(all[i]) === -1; // Do not close descendants' submenus
            }

            if (close) {
                deactivate_menu_item(all[i]);
            }
        }
    }

    /**
     * Event: Handle mouse enter hover
     */
    function menu_item_mouseenter(e) {
        // console.log('Mouse enter');

        let li = e.currentTarget;

        if (is_desktop_menu() && menu_item_has_submenu(li)) {
            // Find an identifier for the menu item
            let id = menu_item_get_identifier(li);

            // Clear any previously set closing timeout *for this menu item*
            clearTimeout(hover_timeout[id]);
            // console.log('Clearing timeout for ' + id);

            // hide other submenus
            close_submenus(li, true, true);

            // activate hovered <li>
            activate_menu_item(li);
        }
    }

    /**
     * Event: Handle mouseleave hover
     *
     * Close menu when hover timer has ended (only for desktop menus)
     */
    var menu_item_mouseleave = function (e) {
        // console.log('Mouse leave');

        let li = e.currentTarget;

        if (is_desktop_menu() && menu_item_has_submenu(li)) {
            // Find an identifier for the menu item
            let id = menu_item_get_identifier(li);

            // Add a timeout *for this menu item* to close the menu item's submenu
            // when the cursor has stayed outside of the menu item for a set time
            // console.log('Adding timeout for ' + id);
            hover_timeout[id] = setTimeout(
                function (li) {
                    deactivate_menu_item(li);
                },
                1000,
                li
            );
        }
    };

    function caret_toggle(li, tap = false) {
        // console.log('caret toggle');

        if (is_desktop_menu()) {
            // Find an identifier for the menu item
            let id = menu_item_get_identifier(li);

            // clear any previously set closing timeout
            clearTimeout(hover_timeout[id]);

            // close other submenus
            close_submenus(li, true);
        }

        toggle_menu_item(li);
    }

    /**
     * Event: Dropdown caret clicked
     *
     * Open sub-menu and change caret state
     */
    var caret_click_event = function (e) {
        // console.log('Caret click: Event type=' + e.type);

        // Get menu item <li>
        let li = get_closest_ancestor(
            e.currentTarget,
            'menu-item-has-children'
        );

        caret_toggle(li);

        if (is_desktop_menu()) {
            if (e.type === 'touchstart') {
                e.currentTarget.classList.add('-is-tapped');
            }
        }

        // don't trigger parent(s)
        e.stopPropagation();

        // This function is bound to both 'touchstart' and 'click' event types
        // Preventing this function from running twice when running at 'touchstart'
        if (e.type === 'touchstart') {
            e.preventDefault();
        }
    };

    /**
     * Event: Click on an anchor link (a[href="#something"])
     */
    function anchor_link_click_event(e) {
        // console.log('anchor link click event');

        // Close modals
        // ------------
        // This is needed to get the mobile menu out of the way when clicking an anchor link
        sohova_modal_close_all();
    }

    /**
     * Event: Touch outside menu after menu has been opened with single tap
     *
     * Closes menus if touch is outside of menus
     */
    function outside_menu_touch_event(e) {
        // console.log('Outside menu touch event');
        // if (!is_desktop_menu()) {
        //     return;
        // }
        // close_submenus();
    }

    /**
     * Event: Menu item <a> touched
     *
     * In desktop menu, open sub-menu with first tap and navigate
     * only when tapped a second time
     */
    function link_touch_event(e) {
        // console.log('link touch event');

        if (!is_desktop_menu()) {
            return;
        }

        // Get menu item <li>
        let li = get_closest_ancestor(
            e.currentTarget,
            'menu-item-has-children'
        );

        // Get the caret
        let caret = menu_item_get_caret(li);

        // First tap
        // ---------
        // Check if either the link or the caret has been tapped
        // When tapping the link (the <a> element), "-is-tapped" -class is added to the <li> element
        // When tapping the caret, "-is-tapped" -class is added to the caret
        if (
            !li.classList.contains('-is-tapped') &&
            !caret.classList.contains('-is-tapped')
        ) {
            // don't go to <a> yet
            e.preventDefault();

            // close other submenus
            close_submenus(li, true);

            // add .-is-tapped class to indicate the item has been tapped and open submenu
            li.classList.add('-is-tapped');
            activate_menu_item(li);
        }

        // Second tap can go through normally (the link is activated and the browser takes the user to the new url)
    }

    /**
     * Event: Menu item <a> with no href clicked
     */
    function no_href_click_event(e) {
        // console.log('no href click event');

        // Get menu item <li>
        let li = get_closest_ancestor(
            e.currentTarget,
            'menu-item-has-children'
        );

        // Toggle submenu
        caret_toggle(li, true);

        // don't trigger parent(s)
        e.stopPropagation();

        // This function is bound to both 'touchstart' and 'click' event types
        // Preventing this function from running twice when running at 'touchstart'
        if (e.type === 'touchstart') {
            e.preventDefault();
        }
    }

    /**
     * Init
     */
    function init_dropdown_menu() {
        // all menus are closed when page loads

        // if this is the mobile primary menu
        if (
            menu.classList.contains('primary-navigation') &&
            menu.classList.contains('-mobile')
        ) {
            // open the submenu (tree) where the current page is, if any
            let cur_ancestors = menu.querySelectorAll('.current-page-ancestor');
            for (let i = 0; i < cur_ancestors.length; i++) {
                activate_menu_item(cur_ancestors[i]);
            }

            // open the submenu of the current page, if any
            let cur_page = menu.querySelectorAll(
                '.current-menu-item.menu-item-has-children'
            );
            activate_menu_item(cur_page[0]);
        }

        // setup hover hooks (menu-item)
        let menu_items = menu.querySelectorAll('.menu-item');
        for (let i = 0; i < menu_items.length; i++) {
            menu_items[i].addEventListener('mouseenter', menu_item_mouseenter);
            menu_items[i].addEventListener('mouseleave', menu_item_mouseleave);
        }

        // setup touch and click hooks (carets)
        let menu_carets = menu.querySelectorAll('.js-menu-caret');
        for (let i = 0; i < menu_carets.length; i++) {
            menu_carets[i].addEventListener('touchstart', caret_click_event);
            menu_carets[i].addEventListener('click', caret_click_event);
        }

        // setup click hooks (anchor links)
        let empty_a = menu.querySelectorAll('a[href^="#"]');
        for (let i = 0; i < empty_a.length; i++) {
            empty_a[i].addEventListener('click', anchor_link_click_event);
        }

        // setup click hooks (links with no href)
        let menu_item_no_href = menu.querySelectorAll(
            '.menu-item-has-children a:not([href])'
        );
        for (let i = 0; i < menu_item_no_href.length; i++) {
            menu_item_no_href[i].addEventListener(
                'touchstart',
                no_href_click_event
            );
            menu_item_no_href[i].addEventListener('click', no_href_click_event);
        }

        // setup touch hooks <a>
        let menu_item_a = menu.querySelectorAll(
            '.menu-item-has-children a[href]'
        );
        for (let i = 0; i < menu_item_a.length; i++) {
            menu_item_a[i].addEventListener('touchstart', link_touch_event, {
                passive: false,
            });
        }

        // Add a touchstart listener to the document
        document.addEventListener('touchstart', outside_menu_touch_event, {
            passive: true,
        });
    }
    init_dropdown_menu();

    // make the call chainable
    return this;
};

/**
 * Init dropdown-menus
 */
var dropdown_menus = document.querySelectorAll('.js-navigation');
for (var i = 0; i < dropdown_menus.length; i++) {
    component_dropdown_menu({
        menu: dropdown_menus[i],
    });
}
